export default __webpack_public_path__ + "static/media/movieee.4d364983.jpg";